import imagePathCreator from '../../../../utils/image-path-creator/image-path-creator';
import { formBestsellers } from '../../../../utils/material/material-helper';
import formatPrice from '../../../../utils/price/format-price';

const processCartItems = (cartItems: CartItem[]) => {
    cartItems.forEach((item) => {
        item.thumbNail = imagePathCreator.optimizedImg(item.material, { h: 145 });
        item.finalPrice = formatPrice(item.finalPrice);
        item.originalPrice = formatPrice(item.originalPrice);
        item.bestsellers = formBestsellers(item.material);
    });

    return cartItems;
};

export default processCartItems;
